import { ServiceHelper } from "../../Everou/_services/ServiceHelper";
import { PMS_API_URLS } from "../_constants/PMS_API_URLS";

export const PMSHostifyService = {
    listListings,
}

async function listListings(uid: string, page: number) {
    const response = await ServiceHelper.getRequest(
        PMS_API_URLS.HOSTIFY_LISTINGS,
        {
            uid: uid,
            page: page
        }
    );

    return {
        listings: response.listings,
        next: response.next
    }
}